import { Colors } from "./Colors";

export enum TaskStatus {
  PENDING = "PENDING",
  // Internal setup phase before a task is handed to the client (e.g. a Document Signing step whose
  // preparer must pick the DocuSeal template + signers). Mirrors the backend TaskStatus.CONFIGURATION.
  CONFIGURATION = "CONFIGURATION",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  OVERDUE = "OVERDUE",
  WAITING_FOR_REVIEW = "WAITING_FOR_REVIEW",
}

export const TASK_STATUS_COLORS = {
  [TaskStatus.DONE]: `${Colors.ACCENT_GREEN_01A902}`,
  [TaskStatus.PENDING]: `${Colors.ACCENT_GREY_D7D7DA}`,
  [TaskStatus.CONFIGURATION]: `${Colors.LAZO_PURPLE}`,
  [TaskStatus.IN_PROGRESS]: `${Colors.YELLOW_F1D95A}`,
  [TaskStatus.OVERDUE]: `${Colors.HEART_RED}`,
  [TaskStatus.WAITING_FOR_REVIEW]: `${Colors.BLUE_9AA9F9}`,
};

export const showTaskStatus = (type: TaskStatus) => {
  switch (type) {
    case TaskStatus.DONE:
      return "Done";
    case TaskStatus.CONFIGURATION:
      return "Configuration";
    case TaskStatus.IN_PROGRESS:
      return "In progress";
    case TaskStatus.OVERDUE:
      return "Overdue";
    case TaskStatus.PENDING:
      return "Pending";
    case TaskStatus.WAITING_FOR_REVIEW:
      return "Waiting for review";
    default:
      return "Placeholder";
  }
};

export const TASK_STATUSES = [
  { label: "Done", value: TaskStatus.DONE },
  { label: "Configuration", value: TaskStatus.CONFIGURATION },
  { label: "In progress", value: TaskStatus.IN_PROGRESS },
  { label: "Overdue", value: TaskStatus.OVERDUE },
  { label: "Pending", value: TaskStatus.PENDING },
  { label: "Waiting for review", value: TaskStatus.WAITING_FOR_REVIEW },
];
